import { api } from "@/api/api";

export const Category = {
    state: {
        categoryList: [],
        subCategoryList: [],
    },
    getters: {
        getCategoryList(state) {
            return state.categoryList;
        },
        getSubCategoryList(state) {
            return state.subCategoryList;
        },
    },
    mutations: {
        setCategoryList(state, payload) {
            state.categoryList = payload;
        },
        setSubCategoryList(state, payload) {
            state.subCategoryList = payload;
        },
    },
    actions: {
        async getCategoryList({ commit }) {
            await api.category
                .getCategoryList()
                .then((res) => {
                    commit("setCategoryList", res.data);
                })
                .catch((err) => {
                    console.log(err);
                });
            return Promise.resolve();
        },

        async getSubCategoryList({ commit }, mainCategory) {
            await api.category
                .getSubCategoryList(mainCategory)
                .then((res) => {
                    console.log(res);
                    commit("setSubCategoryList", res.data);
                })
                .catch((err) => {
                    console.log(err);
                });
            return Promise.resolve();
        },

        async getSubCategorySolutionList({ commit }, mainCategory) {
            await api.category
                .getSubCategorySolutionList(mainCategory)
                .then((res) => {
                    console.log(res);
                    commit("setSubCategoryList", res.data);
                })
                .catch((err) => {
                    console.log(err);
                });
            return Promise.resolve();
        },

        async getSubCategoryDownloadList({ commit }, mainCategory) {
            await api.category
                .getSubCategoryDownloadList(mainCategory)
                .then((res) => {
                    console.log(res);
                    commit("setSubCategoryList", res.data);
                })
                .catch((err) => {
                    console.log(err);
                });
            return Promise.resolve();
        },

        async getCategory(_, id) {
            const response = await api.category.getCategory(id).catch((err) => {
                console.log(err);
                return Promise.reject(err.response.data.message);
            });
            return Promise.resolve(response.data);
        },

        async addCategory({ dispatch }, args) {
            await api.category
                .addCategory(args)
                .then(() => {
                    dispatch("getCategoryList");
                })
                .catch((err) => {
                    console.log(err);
                    return Promise.reject(err.response.data.message);
                });
            return Promise.resolve();
        },

        async updateCategory({ dispatch }, args) {
            await api.category
                .updateCategory(args)
                .then(() => {
                    dispatch("getCategoryList");
                })
                .catch((err) => {
                    console.log(err);
                });
            return Promise.resolve();
        },

        async deleteCategory({ dispatch }, args) {
            await api.category
                .deleteCategory(args)
                .then(() => {
                    dispatch("getCategoryList");
                })
                .catch((err) => {
                    console.log(err);
                });
            return Promise.resolve();
        },
    },
};
